import { useState, useCallback } from 'react';
import { useInjection } from '../../../di_container/InjectionProvider';
export const useGoogleMap = () => {
    const { container } = useInjection();
    const [loadingGeocode, setLoadingGeocode] = useState(false);
    const geocoding = useCallback(async (address) => {
        setLoadingGeocode(true);
        try {
            const repository = container.resolve('GoogleMapRepository');
            const result = await repository.geocoding(address);
            setLoadingGeocode(false);
            return result;
        }
        catch (e) {
            setLoadingGeocode(false);
            throw e;
        }
    }, []);
    return {
        loadingGeocode,
        geocoding,
    };
};
